import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {IconContainerDefaultBox} from "./icon-container.default.box";
import {IconContainerMrgreenBox} from "./icon-container.mrgreen.box";

export const IconContainerBox = styledByTheme(IconContainerDefaultBox).forMrGreen(IconContainerMrgreenBox).apply();